import CustomConfirm from 'components/CustomConfirmModal';
import CustomFilePreviewModal from 'components/CustomFilePreviewModal';
import FilePreviewModal from 'components/FilePreviewModal';
import IntegrationFilePreviewModal from 'components/IntegrationFilePreviewModal';
import MessageApplicantsModal from 'components/MessageApplicantsModal';
import { AddDepartmentModal } from 'components/modals/add-department';
import { AddUserToDepartmentModal } from 'components/modals/add-department-user';
import { AddJobLabelModal } from 'components/modals/add-job-label';
import { AddUserAppModal } from 'components/modals/add-user-app';
import { AddDepartmentUserModal } from 'components/modals/add-users-to-department';
import { AddAuthenticator } from 'components/modals/AddAuthenticator';
import { AddSMSAuthenticator } from 'components/modals/AddSMSAuthenticator';
import { AssignUserToApplicantModal } from 'components/modals/assign-user-to-application';
import { BulkActiveApplicantsModal } from 'components/modals/bulk-active-applicants';
import { BulkDeleteApplicantsModal } from 'components/modals/bulk-delete-applicants';
import { BulkHireApplicantsModal } from 'components/modals/bulk-hire-applicants';
import { BulkRetractApplicantsModal } from 'components/modals/bulk-retract-applicants';
import { ConfirmModal } from 'components/modals/confirm-modal';
import { DeleteDepartmentModal } from 'components/modals/delete-department';
import { DeleteDepartmentUserModal } from 'components/modals/delete-department-user';
import { DeleteJobLabelModal } from 'components/modals/delete-job-label';
import { DeleteUserAppModal } from 'components/modals/delete-user-app';
import EditApplicationAccessModal from 'components/modals/edit-application-access-modal';
import { EditDepartmentModal } from 'components/modals/edit-department';
import { EditDepartmentUserModal } from 'components/modals/edit-department-user';
import { ExportApplicants } from 'components/modals/ExportApplicants';
import { ExportJobModal } from 'components/modals/ExportJobModal';
import { ExportJobs } from 'components/modals/ExportJobs';
import { HireApplicantModal } from 'components/modals/hire-applicant';
import { DeleteLocationModal } from 'components/modals/locations/delete-location';
import { LocationModal } from 'components/modals/locations/location-form';
import { NotifyTwoFactor } from 'components/modals/NotifyTwoFactor';
import { OnboardApplicantModal } from 'components/modals/onboard-applicant';
import { RemoveApplicationModal } from 'components/modals/remove-application';
import { RemoveAuthenticator } from 'components/modals/RemoveAuthenticator';
import { RetractApplicantModal } from 'components/modals/retract-applicant';
import { EditGoogleAnalyticsModal } from 'components/modals/settings/edit-google-analytics-modal';
import { EditMessagesSenderNameModal } from 'components/modals/settings/edit-messages-sender-name-modal';
import { EditPrivacyPolicyUrlModal } from 'components/modals/settings/edit-privacy-policy-url-modal';
import { SSORequiredModal } from 'components/modals/SSORequired';
import SSOSignin from 'components/modals/SSOSignin';
import { UserAppCredentialsModal } from 'components/modals/user-app-credentials';
import RejectApplicantsModal from 'components/RejectApplicantsModal';
import CommonRemoveConfirm from 'components/RemoveConfirmModal';
import { ShareJobModal } from 'components/ShareJob/SharingJobSiteModal';
import { UserModalCreate } from 'components/UserModalCreate';
import { UserModalEdit } from 'components/UserModalEdit';
import { ADManagerAddTemplateModal } from 'integrations/adManager/add-template-modal';
import { ADManagerBulkCreateUsersModal } from 'integrations/adManager/bulk-create-user-modal';
import { ADManagerCreateUserModal } from 'integrations/adManager/create-user-modal';
import { DokobitCosignerModal } from 'integrations/dokobit/cosigner-modal';
import { DokobitEditCosignerModal } from 'integrations/dokobit/edit-cosigner-modal';
import { HireflixBulkSendInterviewModal } from 'integrations/hireflix/BulkSendInterviewModal';
import { HireflixReviewsModal } from 'integrations/hireflix/ReviewsModal';
import { HireflixSendInterviewModal } from 'integrations/hireflix/SendInterviewModal';
import { OnboardingFormBulkSendModal } from 'integrations/onboardingForm/bulk-send-form-modal';
import { CompletionTemplateModal } from 'integrations/onboardingForm/completion-templates-modal';
import { NotifyEmailModal } from 'integrations/onboardingForm/notify-email-modal';
import { OnboardingFormResendModal } from 'integrations/onboardingForm/onboarding-form-resend';
import { OnboardingSmsMessageModal } from 'integrations/onboardingForm/onboarding-sms-message-modal';
import { SignetConnectModal } from 'integrations/signet/connect-modal';
import { SignetCosignerModal } from 'integrations/signet/cosigner-modal';
import { TaktikalConnectModal } from 'integrations/taktikal/connect-modal';
import { TaktikalCosignerModal } from 'integrations/taktikal/cosigner-modal';
import QuestionModal from 'pages/CreateJob/ApplicationForm/QuestionModal';
import PublishedModal from 'pages/CreateJob/Preview/PublishedModal';
import { ShareJobFromCreateModal } from 'pages/CreateJobNew/share-job-modal';
import { UnsavedChangesModal } from 'pages/CreateJobNew/unsaved-changes-modal';
import AddApplicantModal from 'pages/Job/AddApplicantModal';
import AddApplicationAccessModal from 'pages/Job/Application/AddApplicationAccessModal';
import { ConfirmNoQuestions } from 'pages/Job/Application/ApplicationMoveCopy';
import EditApplicantModal from 'pages/Job/Application/EditModal';
import MoveApplicationModal from 'pages/Job/Application/MoveApplicationModal';
import GrantMultipleModal from 'pages/Job/GrantMultipleModal';
import MoveToStageModal from 'pages/Job/MoveToStageModal';
import { ArchiveAllModal } from 'pages/notifications/archive-all-modal';
import { MarkAllAsReadModal } from 'pages/notifications/mark-all-as-read-modal';
import { AddBlackListEmail } from 'pages/Settings/Blacklist/add-email-modal';
import { ShareModal } from 'pages/Sharing/SharingCareerSiteModal';

export const modalsMap = {
  ADD_APPLICANT: AddApplicantModal,
  EDIT_APPLICANT: EditApplicantModal,
  ADD_APPLICATION_ACCESS: AddApplicationAccessModal,
  BULK_HIRE_APPLICANTS: BulkHireApplicantsModal,
  BULK_RETRACT_APPLICANTS: BulkRetractApplicantsModal,
  BULK_ACTIVE_APPLICANTS: BulkActiveApplicantsModal,
  BULK_DELETE_APPLICANTS: BulkDeleteApplicantsModal,
  COMMON_REMOVE_CONFIRM: CommonRemoveConfirm,
  CONFIRM_MODAL: ConfirmModal,
  CREATE_USER: UserModalCreate,
  CUSTOM_CONFIRM: CustomConfirm,
  EDIT_CANDIDATE_ACCESS: EditApplicationAccessModal,
  EDIT_USER: UserModalEdit,
  GRANT_MULTIPLE: GrantMultipleModal,
  MOVE_TO_STAGE: MoveToStageModal,
  HIRE_APPLICANT: HireApplicantModal,
  RETRACT_APPLICANT: RetractApplicantModal,
  MOVE_APPLICATION_MODAL: MoveApplicationModal,
  JOB_PUBLISHED: PublishedModal,
  ONBOARD_APPLICANT: OnboardApplicantModal,
  QUESTION: QuestionModal,
  REJECT_APPLICANTS: RejectApplicantsModal,
  MESSAGE_APPLICANTS: MessageApplicantsModal,
  REMOVE_APPLICATION: RemoveApplicationModal,
  ASSIGN_APPLICANT: AssignUserToApplicantModal,
  CONFIRM_MOVE_NO_QUESTIONS: ConfirmNoQuestions,
  EXPORT_JOB: ExportJobModal,
  EXPORT_APPLICANTS: ExportApplicants,
  EXPORT_JOBS: ExportJobs,
  REMOVE_AUTHENTICATOR: RemoveAuthenticator,
  ADD_AUTHENTICATOR: AddAuthenticator,
  ADD_SMS_AUTHENTICATOR: AddSMSAuthenticator,
  NOTIFY_TWO_FACTOR: NotifyTwoFactor,
  SSO_SIGNIN: SSOSignin,
  SSO_REQUIRED: SSORequiredModal,
  SHARE_MODAL: ShareModal,
  SHARE_JOB_MODAL: ShareJobModal,
  SHARE_JOB_FROM_CREATE_MODAL: ShareJobFromCreateModal,
  ADD_DEPARTMENT: AddDepartmentModal,
  EDIT_DEPARTMENT: EditDepartmentModal,
  DELETE_DEPARTMENT: DeleteDepartmentModal,
  ADD_DEPARTMENT_USER: AddDepartmentUserModal,
  EDIT_DEPARTMENT_USER: EditDepartmentUserModal,
  ADD_USER_TO_DEPARTMENT: AddUserToDepartmentModal,
  DELETE_DEPARTMENT_USER: DeleteDepartmentUserModal,
  DELETE_USER_APP: DeleteUserAppModal,
  ADD_USER_APP: AddUserAppModal,
  USER_APP_CREDENTIALS: UserAppCredentialsModal,
  EDIT_MESSAGES_SENDER_NAME: EditMessagesSenderNameModal,
  EDIT_GOOGLE_ANALYTICS: EditGoogleAnalyticsModal,
  EDIT_PRIVACY_POLICY_URL: EditPrivacyPolicyUrlModal,
  LOCATION_FORM: LocationModal,
  DELETE_LOCATION: DeleteLocationModal,
  NOTIFICATIONS_MARK_ALL_AS_READ: MarkAllAsReadModal,
  NOTIFICATIONS_ARCHIVE_ALL: ArchiveAllModal,
  JOB_UNSAVED_CHANGES: UnsavedChangesModal,
  DELETE_JOB_LABEL: DeleteJobLabelModal,
  ADD_JOB_LABEL: AddJobLabelModal,
  SETTINGS_ADD_BLACKLIST_EMAIL: AddBlackListEmail,

  // Full screen
  FILE_PREVIEW: FilePreviewModal,
  INTEGRATION_FILE_PREVIEW: IntegrationFilePreviewModal,
  CUSTOM_FILE_PREVIEW: CustomFilePreviewModal,

  // Integrations
  INTEGRATION_HIREFLIX_SEND_INTERVIEW: HireflixSendInterviewModal,
  INTEGRATION_HIREFLIX_BULK_SEND_INTERVIEW: HireflixBulkSendInterviewModal,
  INTEGRATION_HIREFLIX_REVIEWS: HireflixReviewsModal,
  INTEGRATION_ONBOARDING_FORM_SEND: OnboardingFormBulkSendModal,
  INTEGRATION_ONBOARDING_FORM_SMS_MESSAGE: OnboardingSmsMessageModal,
  INTEGRATION_ONBOARDING_FORM_COMPLETION_TEMPLATES: CompletionTemplateModal,
  INTEGRATION_ONBOARDING_FORM_RESEND: OnboardingFormResendModal,
  INTEGRATION_ONBOARDING_FORM_NOTIFY_EMAIL: NotifyEmailModal,
  INTEGRATION_DOKOBIT_ADD_COSIGNER: DokobitCosignerModal,
  INTEGRATION_DOKOBIT_EDIT_COSIGNER: DokobitEditCosignerModal,
  INTEGRATION_ADMANAGER_CREATE_USER: ADManagerCreateUserModal,
  INTEGRATION_ADMANAGER_BULK_CREATE_USER: ADManagerBulkCreateUsersModal,
  INTEGRATION_ADMANAGER_ADD_TEMPLATE: ADManagerAddTemplateModal,
  INTEGRATION_SIGNET_CONNECT: SignetConnectModal,
  INTEGRATION_SIGNET_COSIGNER: SignetCosignerModal,
  INTEGRATION_TAKTIKAL_CONNECT: TaktikalConnectModal,
  INTEGRATION_TAKTIKAL_COSIGNER: TaktikalCosignerModal,
} as const;

export type ModalMapType = typeof modalsMap;
export type ModalType = keyof typeof modalsMap;
